import { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { AdviseCurrentSupplier, AdviseSupplierInvoice } from '../../../../types/advise';
import { useEngagementEditor } from './EngagementEditorContext';
import { InvoiceLinesTab } from './InvoiceLinesTab';
import { ManualSpendEntry } from './ManualSpendEntry';
import { OriginalInvoicePanel } from './OriginalInvoicePanel';

export interface InvoiceTabsProps {
  supplier: AdviseCurrentSupplier;
  invoice: AdviseSupplierInvoice;
  onChangedChange: (changed: boolean) => void;
}

// Lines entered by hand stay mounted behind Original Invoice, so what is typed survives a look at it.
export const InvoiceTabs = ({ supplier, invoice, onChangedChange }: InvoiceTabsProps) => {
  const { engagement } = useEngagementEditor();
  const [tab, setTab] = useState<'lines' | 'original'>('lines');
  const parsed = invoice.status === 'parsed';
  return (
    <>
      <Tabs
        value={tab}
        onChange={(_event, next) => setTab(next)}
        className="border-b border-grey-2">
        <Tab
          value="lines"
          label={parsed ? 'Parsed Line Items' : 'Line Items'}
        />
        <Tab
          value="original"
          label="Original Invoice"
        />
      </Tabs>
      {parsed && tab === 'lines' && (
        <InvoiceLinesTab
          supplier={supplier}
          invoice={invoice}
        />
      )}
      {!parsed && (
        <div hidden={tab !== 'lines'}>
          <ManualSpendEntry
            supplier={supplier}
            invoice={invoice}
            onChangedChange={onChangedChange}
          />
        </div>
      )}
      {tab === 'original' && (
        <OriginalInvoicePanel
          engagementId={engagement.id}
          supplierId={supplier.id}
          invoice={invoice}
        />
      )}
    </>
  );
};
